/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Health update request containing sync status and details
 * @export
 * @interface XsoarHealthUpdateRequest
 */
export interface XsoarHealthUpdateRequest {
    /**
     * Timestamp of the last successful sync
     * @type {Date}
     * @memberof XsoarHealthUpdateRequest
     */
    lastSyncTimestamp: Date;
    /**
     * Status of the last sync operation
     * @type {string}
     * @memberof XsoarHealthUpdateRequest
     */
    syncStatus: XsoarHealthUpdateRequestSyncStatusEnum;
    /**
     * Additional sync details and metrics
     * @type {{ [key: string]: any; }}
     * @memberof XsoarHealthUpdateRequest
     */
    syncDetails?: { [key: string]: any; };
    /**
     * Error message if sync failed
     * @type {string}
     * @memberof XsoarHealthUpdateRequest
     */
    errorMessage?: string;
    /**
     * Integration status
     * @type {string}
     * @memberof XsoarHealthUpdateRequest
     */
    integrationStatus?: XsoarHealthUpdateRequestIntegrationStatusEnum;
}


/**
 * @export
 */
export const XsoarHealthUpdateRequestSyncStatusEnum = {
    Success: 'success',
    Failed: 'failed',
    Partial: 'partial',
    InProgress: 'in progress'
} as const;
export type XsoarHealthUpdateRequestSyncStatusEnum = typeof XsoarHealthUpdateRequestSyncStatusEnum[keyof typeof XsoarHealthUpdateRequestSyncStatusEnum];

/**
 * @export
 */
export const XsoarHealthUpdateRequestIntegrationStatusEnum = {
    Active: 'active',
    Inactive: 'inactive',
    Suspended: 'suspended'
} as const;
export type XsoarHealthUpdateRequestIntegrationStatusEnum = typeof XsoarHealthUpdateRequestIntegrationStatusEnum[keyof typeof XsoarHealthUpdateRequestIntegrationStatusEnum];


/**
 * Check if a given object implements the XsoarHealthUpdateRequest interface.
 */
export function instanceOfXsoarHealthUpdateRequest(value: object): value is XsoarHealthUpdateRequest {
    if (!('lastSyncTimestamp' in value) || value['lastSyncTimestamp'] === undefined) return false;
    if (!('syncStatus' in value) || value['syncStatus'] === undefined) return false;
    return true;
}

export function XsoarHealthUpdateRequestFromJSON(json: any): XsoarHealthUpdateRequest {
    return XsoarHealthUpdateRequestFromJSONTyped(json, false);
}

export function XsoarHealthUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): XsoarHealthUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'lastSyncTimestamp': (new Date(json['last_sync_timestamp'])),
        'syncStatus': json['sync_status'],
        'syncDetails': json['sync_details'] == null ? undefined : json['sync_details'],
        'errorMessage': json['error_message'] == null ? undefined : json['error_message'],
        'integrationStatus': json['integration_status'] == null ? undefined : json['integration_status'],
    };
}

export function XsoarHealthUpdateRequestToJSON(json: any): XsoarHealthUpdateRequest {
    return XsoarHealthUpdateRequestToJSONTyped(json, false);
}

export function XsoarHealthUpdateRequestToJSONTyped(value?: XsoarHealthUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'last_sync_timestamp': ((value['lastSyncTimestamp']).toISOString()),
        'sync_status': value['syncStatus'],
        'sync_details': value['syncDetails'],
        'error_message': value['errorMessage'],
        'integration_status': value['integrationStatus'],
    };
}

